import type { FC, ReactElement, ReactNode } from 'react';

import { getBrowserName } from 'utils/getBrowserName';

import Chrome from './Chrome';
import Edge from './Edge';
import Firefox from './Firefox';
import Opera from './Opera';
import Safari from './Safari';
import Unknown from './Unknown';
import Yandex from './Yandex';

const browserName = getBrowserName();

type BrowsersToUse = ReturnType<typeof getBrowserName>;

/** Получить компонент в зависимости от браузера */
export const getBrowserView = () => {
    const contentList: Record<BrowsersToUse, ReactElement> = {
        Chrome: <Chrome />,
        Edge: <Edge />,
        Firefox: <Firefox />,
        'Mobile Safari': <Safari />,
        Opera: <Opera />,
        Safari: <Safari />,
        Yandex: <Yandex />,
    };

    const result: ReactNode | undefined = contentList[browserName];

    return result ?? <Unknown />;
};

const Browsers: FC = () => {
    return getBrowserView();
};

export default Browsers;
